import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-categories-two',
  templateUrl: './categories-two.component.html',
  styleUrls: ['./categories-two.component.scss']
})
export class CategoriesTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
